import request from '@/utils/request'
import { v2Host } from '@/config/host'
import type { ChannelModel, _Response } from '../type'
import { CreativeInfo } from './type'

// 素材信息
export function getCreativeInfo(basic_id: number): _Response<CreativeInfo> {
  return request({
    url: `${v2Host}/creative/info?basic_id=${basic_id}`,
    method: 'get',
  })
}

export function getCreativeInfoChannels(params: {
  ids: string
}): _Response<{ list: ChannelModel[] | null }> {
  return request({
    url: `${v2Host}/creative/info/channels`,
    method: 'get',
    params,
  })
}

export function downloadPtPlayable(params) {
  return request({
    url: `${v2Host}/creative/download/download`,
    method: 'get',
    params,
  })
}

export function downloadHistoryPlayable(params: { ids: string; name: string }) {
  return request({
    url: `${v2Host}/creative/download/history-download`,
    method: 'get',
    params,
  })
}
